/* eslint-disable */
import { BehaviorSubject, Subject } from "rxjs";
import { isAuth, getToken } from "../../../auth/shared/utils/auth";
import { get } from "../../../http";

export type Price = {
  id: number;
  name: string;
  current: number;
  peak: number;
  pricesGroupId: number;
};

export type PricesGroup = {
  id: string;
  name: string;
  date: Date;
  source: string;
  prices: Price[];
};

export enum PricesError {
  Network,
  Server,
  InvalidCredentials,
  NotVerified,
}

export class PricesService {
  private _baseUrl: string;
  private _prices$ = new BehaviorSubject<PricesGroup[]>([]);
  private _error$ = new Subject<PricesError>();
  private _loading$ = new BehaviorSubject<boolean>(false);

  public get error$() {
    return this._error$.asObservable();
  }

  public get prices$() {
    return this._prices$.asObservable();
  }

  public get prices() {
    return this._prices$.value;
  }

  public get loading$() {
    return this._loading$.asObservable();
  }

  public get loading() {
    return this._loading$.value;
  }

  constructor(apiUrl?: string) {
    this._baseUrl = (apiUrl || "/api") + "/Prices";
  }

  // TODO Вынести в глобальный метод добавление заголовка
  addAuthInHeadersOption = () => {
    let options = {};
    if (isAuth()) {
      const token = getToken();
      options = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
    }
    return options;
  };

  async getPrices() {
    try {
      this._loading$.next(true);

      // TODO Раскомментировать когда будет реализован API
      const result = await get(`${this._baseUrl}`);
      result.json().then((res) => {
        res.forEach(group => {
          group.date = new Date(group.date);
        });
        this._prices$.next(res);
      });

      this._loading$.next(false);
    } catch (err) {
      this._loading$.next(false);

      // TODO: Добавить логику обработки ошибок
      // eslint-disable-next-line no-console
      console.error("get price fail");
      // eslint-disable-next-line no-console
      console.error(err);
      throw err;
    }
  }
}
